import { configureStore } from '@reduxjs/toolkit';
import { userSlice } from './slices/user';
import { numbersSlice } from './slices/numbers';
import { storeSlice } from '@/redux/slices/store';
import { helpersSlice } from '@/redux/slices/helpers';
import { adminSlice } from '@/redux/slices/admin';
import { apiMiddleware } from '@/redux/apiMiddleware';
import { notificationsSlice } from '@/redux/slices/notifications';
import { domainsSlice } from '@/redux/slices/domains';

const middleware = [apiMiddleware];

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    numbers: numbersSlice.reducer,
    store: storeSlice.reducer,
    helpers: helpersSlice.reducer,
    admin: adminSlice.reducer,
    notifications: notificationsSlice.reducer,
    domains: domainsSlice.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(...middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
